import { Config } from "@app/config";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormIncomeSimpleData } from "@shared/ui";
import { ButtonLegacy, FormIncomeSimple } from "@shared/ui";
import { formatText } from "@shared/ui/format";
import autobind from "autobind-decorator";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export interface Step4Fields {
	incomeList: FormIncomeSimpleData[];
}

export class Step4 extends AbstractStep<Step4Fields> {
	protected initValues(): Step4Fields {
		return {
			incomeList: [],
		};
	}

	protected renderContent(_values: Step4Fields, form: FormApi<Step4Fields>): ReactNode {
		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">
						Add meg, milyen havi jövedelmekkel rendelkezik a háztartásod!
					</Card.Title>
				</Card.Header>
				<Card.Body>
					<FormIncomeSimple
						name="incomeList"
						apiAddress={Config.getApiUrl("/api/public/bank/loan/mortgage/income-types")}
						validate={this.validIncomeList}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	@autobind
	private validIncomeList(incomeList: FormIncomeSimpleData[]): string {
		const totalIncome = incomeList.reduce((sum, income) => sum + income.amount, 0);

		if (totalIncome === 0) {
			return "Adj meg legalább egy jövedelmet!";
		}

		if (totalIncome < Config.getMinWage()) {
			return `A megadható minimális összjövedelem ${formatText(
				Config.getMinWage(),
				"ft",
			)}, amely megegyezik az aktuális minimálbérrel.`;
		}

		return undefined;
	}

	protected getComponentName(): string {
		return "Step4";
	}
}
